import { Reducer, Action } from 'redux';
import { CompanyReportsAdminListState } from './types-store';
import {
  ACTION, ClearList,
  RequestList, ReceiveList, FailList,
  RequestDeleteCompanyReport, ReceiveDeleteCompanyReport, FailDeleteCompanyReport
} from './action-types';

export const INITIAL_STATE: CompanyReportsAdminListState = {
  requestId: 0,
  fetching: false,
  requestedSearchModel: undefined,
  numberOfResults: undefined,
  listItems: undefined,
  deletingCompanyReports: []
};

const reducers: { [indexer: string]: Reducer<CompanyReportsAdminListState, Action> } = {

  [ACTION.CLEAR_LIST]: (state: CompanyReportsAdminListState, action: ClearList): CompanyReportsAdminListState => {
    return {
      ...state,
      requestId: action.requestId,
      fetching: false,
      requestedSearchModel: undefined,
      numberOfResults: undefined,
      listItems: undefined,
      deletingCompanyReports: []
    };
  },

  [ACTION.REQUEST_LIST]: (state: CompanyReportsAdminListState, action: RequestList): CompanyReportsAdminListState => {

    return {
      ...state,
      requestId: action.requestId,
      fetching: true,
      requestedSearchModel: action.model,
      ...(action.clearResults && {
        numberOfResults: undefined,
        listItems: undefined,
        deletingCompanyReports: []
      })
    };
  },

  [ACTION.RECEIVE_LIST]: (state: CompanyReportsAdminListState, action: ReceiveList): CompanyReportsAdminListState => {

    if (action.requestId !== state.requestId) {
      return state;
    }

    return {
      ...state,
      fetching: false,
      numberOfResults: action.numberOfResults,
      listItems: [
        ...(state.listItems || []),
        ...action.list
      ]
    };
  },

  [ACTION.FAIL_LIST]: (state: CompanyReportsAdminListState, action: FailList): CompanyReportsAdminListState => {

    if (action.requestId !== state.requestId) {
      return state;
    }

    return {
      ...state,
      fetching: false
    };
  },

  [ACTION.REQUEST_DELETE_COMPANY_REPORT]: (state: CompanyReportsAdminListState,
    action: RequestDeleteCompanyReport): CompanyReportsAdminListState => {

    return !state.deletingCompanyReports || !state.deletingCompanyReports.includes(action.id)
      ? {
        ...state,
        deletingCompanyReports: [
          ...(state.deletingCompanyReports || []),
          action.id
        ]
      }
      : state;
  },

  [ACTION.RECEIVE_DELETE_COMPANY_REPORT]: (state: CompanyReportsAdminListState,
    action: ReceiveDeleteCompanyReport): CompanyReportsAdminListState => {

    if (!state.deletingCompanyReports || !state.deletingCompanyReports.includes(action.id) || !state.listItems?.length) {
      return state;
    }

    const listItems = (state.listItems || []).filter(item => item.code.value !== action.id);

    return {
      ...state,
      listItems,
      numberOfResults: state.numberOfResults - (state.listItems.length - listItems.length),
      deletingCompanyReports: state.deletingCompanyReports.filter(id => id !== action.id)
    };
  },

  [ACTION.FAIL_DELETE_COMPANY_REPORT]: (state: CompanyReportsAdminListState,
    action: FailDeleteCompanyReport): CompanyReportsAdminListState => {

    return state.deletingCompanyReports && state.deletingCompanyReports.includes(action.id)
      ? {
        ...state,
        deletingCompanyReports: state.deletingCompanyReports.filter(id => id !== action.id)
      }
      : state;
  }
};

export const reducer: Reducer<CompanyReportsAdminListState> = (
  state: CompanyReportsAdminListState = INITIAL_STATE, action: Action) => {
  const r = reducers[action.type];
  return (r && r(state, action)) || state;
};
